import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useSelector, useDispatch } from "react-redux";

import DrawerHeader from "./DrawerHeader";
import { agregaMenuActivo } from "../../redux/slices/menuSlice";
import MenuList from "../menu/MenuList";
import Loading from "../common/Loading";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme, isMobile) => {
  return ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: isMobile ? "0px" : `0px`,
  [theme.breakpoints.up("sm")]: {
    width: isMobile ? "0px" : `calc(${theme.spacing(8)} + 1px)`,
  },
})};

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, isMobile }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme, isMobile),
  })
}));

const SideNavBar = ({ open, handleDrawerState, isMobile = false }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { menuList } = useSelector((state) => state.menuReducer);

  const handleAgregaPagina = (pagina) => {
    dispatch(agregaMenuActivo(pagina));
    if (isMobile) handleDrawerState(false);
  };

  return (
    <Drawer
      variant={"permanent"}
      open={open}
      onClose={() => handleDrawerState(false)}
      ModalProps={{
        keepMounted: true,
      }}
      isMobile={isMobile}
      
    >
      <DrawerHeader>
        <IconButton onClick={() => handleDrawerState(false)}>
          {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </DrawerHeader>

      {menuList?.length ? (
        <MenuList
          data={menuList}
          drawerOpen={open}
          onClickMenuItem={handleAgregaPagina}
        />
      ) : (
        <Loading size={30} />
      )}
    </Drawer>
  );
};

export default SideNavBar;
